import React from 'react';
import { Link } from 'react-router-dom';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
/* import { Panel, PanelHeader, PanelBody, PanelFooter } from './../components/panel/panel.jsx';*/
import classnames from 'classnames';
//import Calendar from 'react-calendar';
//import Sparkline from '@rowno/sparkline';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Api } from "./../app-controller.js";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import Moment from 'moment';


class Reports extends React.Component {
	constructor(props) {
		super(props);

		this.toggle = this.toggle.bind(this);
      
		this.state = {
            activeTab: '1',
			num_sol_regente:"0",
			num_sol_establecimientos:"0",
		};
		
		this.lineChartData = {
			labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
			datasets: [{
				label: 'Page Views',
				fill: false,
				lineTension: 0.1,
				backgroundColor: 'rgba(0, 172, 172, 0.25)',
				borderColor: '#00acac',
				borderWidth: 2,
				pointBorderColor: '#00acac',
				pointBackgroundColor: '#fff',
				pointBorderWidth: 2,
				pointHoverRadius: 5,
				pointHoverBackgroundColor: '#fff',
				pointHoverBorderColor: '#00acac',
				pointHoverBorderWidth: 3,
				pointRadius: 3,
				pointHitRadius: 10,
				data: [65, 59, 80, 81, 56, 55, 40, 59, 76, 94, 77, 82]
			},{
				label: 'Visitors',
				fill: false,
				lineTension: 0.1,
				backgroundColor: 'rgba(52, 143, 226, 0.25)',
				borderColor: '#348fe2',
				borderWidth: 2,
				pointBorderColor: '#348fe2',
				pointBackgroundColor: '#fff',
				pointBorderWidth: 2,
				pointHoverRadius: 5,
				pointHoverBackgroundColor: '#fff',
				pointHoverBorderColor: '#348fe2',
				pointHoverBorderWidth: 3,
				pointRadius: 3,
				pointHitRadius: 10,
				data: [25, 29, 40, 45, 16, 15, 20, 39, 26, 44, 57, 32]
			}]
		}
		
		this.lineChartOptions = { 
			maintainAspectRatio: false, 
			scales: { 
				yAxes: [{ 
					ticks: { 
						beginAtZero:true,
						fontColor: 'black'
					}
				}],
				xAxes: [{ 
					ticks: { 
						fontColor: 'black'
					}
				}]
			},
			legend: {
				labels: {
					fontColor: 'black'
				}
			}
		}
		
		this.date = new Date();

		this.startDate = Moment().subtract(7, 'days');
		this.endDate = Moment();
		
		this.dateRange = {
			currentWeek: Moment().subtract('days', 7).format('D MMMM YYYY') + ' - ' + Moment().format('D MMMM YYYY'),
			prevWeek: Moment().subtract('days', 15).format('D MMMM') + ' - ' + Moment().subtract('days', 8).format('D MMMM YYYY')
		}
    }
    
    
   componentDidMount() {
	Api.fetch("app/getNumSolRegent").then((data) => {
		
		this.setState({ num_sol_regente: data[0].num_solicitudes_regente });
	  });
	Api.fetch("app/getNumSolEstablishments").then((data) => {
		
		this.setState({ num_sol_establecimientos: data[0].num_solicitudes_establecimientos });
	});
  } 
	
	toggle(tab) {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab
			});
		}
	}
  
	render() {
		return (
			<div>
				<ol className="breadcrumb float-xl-right">
					<li className="breadcrumb-item"><Link to="/dashboard/v1">Home</Link></li>
					<li className="breadcrumb-item active">Dashboard</li>
				</ol>
				<h1 className="page-header">Dashboard <small>header small text goes here...</small></h1>
				<div className="d-sm-flex align-items-center mb-3">
					<DateRangePicker startDate={this.startDate} endDate={this.endDate} onApply={this.handleDateApplyEvent}>
						<button className="btn btn-inverse mr-2 text-truncate">
							<i className="fa fa-calendar fa-fw text-white-transparent-5 ml-n1"></i> 
							<span>{this.dateRange.currentWeek}</span>
							<b className="caret"></b>
						</button>
					</DateRangePicker>
					<div className="text-muted f-w-600 mt-2 mt-sm-0">compared to <span>{this.dateRange.prevWeek}</span></div>
				</div>
				<div className="row">
					<div className="col-xl-4 col-md-6">
						<div className="widget widget-stats bg-blue">
							<div className="stats-icon stats-icon-lg"><i className="fa fa-users"></i></div>
							<div className="stats-info">
								<h4>SOLICITUDES REGENTE</h4>
								<p>{this.state.num_sol_regente}</p>	
							</div>
							<div className="stats-link">
								<Link to="/dashboard/v1">Ver Detalles <i className="fa fa-arrow-alt-circle-right"></i></Link>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-md-6">
						<div className="widget widget-stats bg-orange">
							<div className="stats-icon stats-icon-lg"><i className="fa fa-building"></i></div>
							<div className="stats-info">
								<h4>SOLICITUDES ESTABLECIMIENTOS</h4>
								<p>{this.state.num_sol_establecimientos}</p>	
							</div>
							<div className="stats-link">
								<Link to="/dashboard/v1">Ver Detalles <i className="fa fa-arrow-alt-circle-right"></i></Link>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-md-6">
						<div className="widget widget-stats bg-green-darker">
							<div className="stats-icon stats-icon-lg"><i className="fa fa-file"></i></div>
							<div className="stats-info">
								<h4>LICENCIAS EMITIDAS</h4>
								<p>0</p>	
							</div>
							<div className="stats-link">
								<Link to="/dashboard/v1">Ver Detalles <i className="fa fa-arrow-alt-circle-right"></i></Link>
							</div>
						</div>
					</div>
					{/* <div className="col-xl-3 col-md-6">
						<div className="widget widget-stats bg-black-lighter">
							<div className="stats-icon"><i className="fa fa-clock"></i></div>
							<div className="stats-info">
								<h4>AVG TIME ON SITE</h4>
								<p>00:12:23</p>	
							</div>
							<div className="stats-link">
								<Link to="/dashboard/v1">View Detail <i className="fa fa-arrow-alt-circle-right"></i></Link>
							</div>
						</div>
					</div> */}
				</div>
				<div className="row">
					<div className="col-xl-12">
						{/* <Panel>
							<PanelHeader>Website Analytics (Last 7 Days)</PanelHeader>
							<PanelBody>
								<Line data={ this.lineChartData } height={ 300 } options={ this.lineChartOptions } />
							</PanelBody>
						</Panel> */}
				
						<Nav tabs className="nav-tabs-inverse nav-justified nav-justified-mobile">
							<NavItem>
								<NavLink className={classnames({ active: this.state.activeTab === '1' })} onClick={() => { this.toggle('1'); }}>
									<i className="fa fa-camera fa-lg m-r-5"></i> <span className="d-none d-md-inline">Latest Post</span>
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink className={classnames({ active: this.state.activeTab === '2' })} onClick={() => { this.toggle('2'); }}>
									<i className="fa fa-archive fa-lg m-r-5"></i> <span className="d-none d-md-inline">Purchase</span>
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink className={classnames({ active: this.state.activeTab === '3' })} onClick={() => { this.toggle('3'); }}>
									<i className="fa fa-envelope fa-lg m-r-5"></i> <span className="d-none d-md-inline">Email</span>
								</NavLink>
							</NavItem>
						</Nav>
						<TabContent activeTab={this.state.activeTab}>
							<TabPane tabId="1">
								<PerfectScrollbar className="height-sm" options={{suppressScrollX: true}}>
									<ul className="media-list media-list-with-divider">
										<li className="media media-lg">
											<Link to="/dashboard/v1" className="pull-left">
												<img className="media-object" src="/assets/img/gallery/gallery-1.jpg" alt="" />
											</Link>
											<div className="media-body">
												<h4 className="media-heading">Aenean viverra arcu nec pellentesque ultrices. In erat purus, adipiscing nec lacinia at, ornare ac eros.</h4>
												Nullam at risus metus. Quisque nisl purus, pulvinar ut mauris vel, elementum suscipit eros. Praesent ornare ante massa, egestas pellentesque orci convallis ut. Curabitur consequat convallis est, id luctus mauris lacinia vel. Nullam tristique lobortis mauris, ultricies fermentum lacus bibendum id. Proin non ante tortor. Suspendisse pulvinar ornare tellus nec pulvinar. Nam pellentesque accumsan mi, non pellentesque sem convallis sed. Quisque rutrum erat id auctor gravida.
											</div>
										</li>
										<li className="media media-lg">
											<Link to="/dashboard/v1" className="pull-left">
												<img className="media-object" src="/assets/img/gallery/gallery-10.jpg" alt="" />
											</Link>
											<div className="media-body">
												<h4 className="media-heading">Vestibulum vitae diam nec odio dapibus placerat. Ut ut lorem justo.</h4>
												Fusce bibendum augue nec fermentum tempus. Sed laoreet dictum tempus. Aenean ac sem quis nulla malesuada volutpat. Nunc vitae urna pulvinar velit commodo cursus. Nullam eu felis quis diam adipiscing hendrerit vel ac turpis. Nam mattis fringilla euismod. Donec eu ipsum sit amet mauris iaculis aliquet. Quisque sit amet feugiat odio. Cras convallis lorem at libero lobortis, placerat lobortis sapien lacinia. Duis sit amet elit bibendum sapien dignissim bibendum.
											</div>
										</li>
										<li className="media media-lg">
											<Link to="/dashboard/v1" className="pull-left">
												<img className="media-object" src="/assets/img/gallery/gallery-7.jpg" alt="" />
											</Link>
											<div className="media-body">
												<h4 className="media-heading">Maecenas eget turpis luctus, scelerisque arcu id, iaculis urna. Interdum et malesuada fames ac ante ipsum primis in faucibus.</h4>
												Morbi placerat est nec pharetra placerat. Ut laoreet nunc accumsan orci aliquam accumsan. Maecenas volutpat dolor vitae sapien ultricies fringilla. Suspendisse vitae orci sed nibh ultrices tristique. Aenean in ante eget urna semper imperdiet. Pellentesque sagittis a nulla at scelerisque. Nam augue nulla, accumsan quis nisi a, facilisis eleifend nulla. Praesent aliquet odio non imperdiet fringilla. Morbi a porta nunc. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae.
											</div>
										</li>
										<li className="media media-lg">
											<Link to="/dashboard/v1" className="pull-left">
												<img className="media-object" src="/assets/img/gallery/gallery-8.jpg" alt="" />
											</Link>
											<div className="media-body">
												<h4 className="media-heading">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec auctor accumsan rutrum.</h4>
												Fusce augue diam, vestibulum a mattis sit amet, vehicula eu ipsum. Vestibulum eu mi nec purus tempor consequat. Vestibulum porta non mi quis cursus. Fusce vulputate cursus magna, tincidunt sodales ipsum lobortis tincidunt. Mauris quis lorem ligula. Morbi placerat est nec pharetra placerat. Ut laoreet nunc accumsan orci aliquam accumsan. Maecenas volutpat dolor vitae sapien ultricies fringilla. Suspendisse vitae orci sed nibh ultrices tristique. Aenean in ante eget urna semper imperdiet. Pellentesque sagittis a nulla at scelerisque.
											</div>
										</li>
									</ul>
								</PerfectScrollbar>
							</TabPane>
							<TabPane tabId="2">
								<PerfectScrollbar className="height-sm" options={{suppressScrollX: true}}>
									<table className="table">
										<thead>
											<tr>
												<th>Date</th>
												<th className="hidden-sm">Product</th>
												<th></th>
												<th>Amount</th>
												<th>User</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>13/02/2013</td>
												<td className="hidden-sm">
													<Link to="/dashboard/v1">
														<img src="/assets/img/product/product-1.png" alt=""  />
													</Link>
												</td>
												<td className="text-nowrap">
													<h6><Link to="/dashboard/v1">Nunc eleifend lorem eu velit eleifend, <br />eget faucibus nibh placerat.</Link></h6>
												</td>
												<td>$349.00</td>
												<td className="text-nowrap"><Link to="/dashboard/v1">Derick Wong</Link></td>
											</tr>
											<tr>
												<td>13/02/2013</td>
												<td className="hidden-sm">
													<Link to="/dashboard/v1">
														<img src="/assets/img/product/product-2.png" alt="" />
													</Link>
												</td>
												<td className="text-nowrap">
													<h6><Link to="/dashboard/v1">Nunc eleifend lorem eu velit eleifend, <br />eget faucibus nibh placerat.</Link></h6>
												</td>
												<td>$399.00</td>
												<td className="text-nowrap"><Link to="/dashboard/v1">Derick Wong</Link></td>
											</tr>
											<tr>
												<td>13/02/2013</td>
												<td className="hidden-sm">
													<Link to="/dashboard/v1">
														<img src="/assets/img/product/product-3.png" alt="" />
													</Link>
												</td>
												<td className="text-nowrap">
													<h6><Link to="/dashboard/v1">Nunc eleifend lorem eu velit eleifend, <br />eget faucibus nibh placerat.</Link></h6>
												</td>
												<td>$499.00</td>
												<td className="text-nowrap"><Link to="/dashboard/v1">Derick Wong</Link></td>
											</tr>
											<tr>
												<td>13/02/2013</td>
												<td className="hidden-sm">
													<Link to="/dashboard/v1">
														<img src="/assets/img/product/product-4.png" alt="" />
													</Link>
												</td>
												<td className="text-nowrap">
													<h6><Link to="/dashboard/v1">Nunc eleifend lorem eu velit eleifend, <br />eget faucibus nibh placerat.</Link></h6>
												</td>
												<td>$230.00</td>
												<td className="text-nowrap"><Link to="/dashboard/v1">Derick Wong</Link></td>
											</tr>
											<tr>
												<td>13/02/2013</td>
												<td className="hidden-tablet hidden-phone">
													<Link to="/dashboard/v1">
														<img src="/assets/img/product/product-5.png" alt="" />
													</Link>
												</td>
												<td className="text-nowrap">
													<h6><Link to="/dashboard/v1">Nunc eleifend lorem eu velit eleifend, <br />eget faucibus nibh placerat.</Link></h6>
												</td>
												<td>$500.00</td>
												<td className="text-nowrap"><Link to="/dashboard/v1">Derick Wong</Link></td>
											</tr>
										</tbody>
									</table>
								</PerfectScrollbar>
							</TabPane>
							<TabPane tabId="3">
								<PerfectScrollbar className="height-sm" options={{suppressScrollX: true}}>
									<ul className="media-list media-list-with-divider">
										<li className="media media-sm">
											<Link to="/dashboard/v1" className="pull-left">
												<img src="/assets/img/user/user-1.jpg" alt="" className="media-object rounded-corner" />
											</Link>
											<div className="media-body">
												<Link to="/dashboard/v1"><h4 className="media-heading">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</h4></Link>
												<p className="m-b-5">
													Aenean mollis arcu sed turpis accumsan dignissim. Etiam vel tortor at risus tristique convallis. Donec adipiscing euismod arcu id euismod. Suspendisse potenti. Aliquam lacinia sapien ac urna placerat, eu interdum mauris viverra.
												</p>
												<i className="text-muted">Received on 04/16/2013, 12.39pm</i>
											</div>
										</li>
										<li className="media media-sm">
											<Link to="/dashboard/v1" className="pull-left">
												<img src="/assets/img/user/user-2.jpg" alt="" className="media-object rounded-corner" />
											</Link>
											<div className="media-body">
												<Link to="/dashboard/v1"><h4 className="media-heading">Praesent et sem porta leo tempus tincidunt eleifend et arcu.</h4></Link>
												<p className="m-b-5">
													Proin adipiscing dui nulla. Duis pharetra vel sem ac adipiscing. Vestibulum ut porta leo. Pellentesque orci neque, tempor ornare purus nec, fringilla venenatis elit. Duis at est non nisl dapibus lacinia.
												</p>
												<i className="text-muted">Received on 04/16/2013, 12.39pm</i>
											</div>
										</li>
										<li className="media media-sm">
											<Link to="/dashboard/v1" className="pull-left">
												<img src="/assets/img/user/user-3.jpg" alt="" className="media-object rounded-corner" />
											</Link>
											<div className="media-body">
												<Link to="/dashboard/v1"><h4 className="media-heading">Ut mi eros, varius nec mi vel, consectetur convallis diam.</h4></Link>
												<p className="m-b-5">
													Ut mi eros, varius nec mi vel, consectetur convallis diam. Nullam eget hendrerit eros. Duis lacinia condimentum justo at ultrices. Phasellus sapien arcu, fringilla eu pulvinar id, mattis quis mauris.
												</p>
												<i className="text-muted">Received on 04/16/2013, 12.39pm</i>
											</div>
										</li>
										<li className="media media-sm">
											<Link to="/dashboard/v1" className="pull-left">
												<img src="/assets/img/user/user-4.jpg" alt="" className="media-object rounded-corner" />
											</Link>
											<div className="media-body">
												<Link to="/dashboard/v1"><h4 className="media-heading">Aliquam nec dolor vel nisl dictum ullamcorper.</h4></Link>
												<p className="m-b-5">
													Aliquam nec dolor vel nisl dictum ullamcorper. Duis vel magna enim. Aenean volutpat a dui vitae pulvinar. Nullam ligula mauris, dictum eu ullamcorper quis, lacinia nec mauris.
												</p>
												<i className="text-muted">Received on 04/16/2013, 12.39pm</i>
											</div>
										</li>
									</ul>
								</PerfectScrollbar>
							</TabPane>
						</TabContent>
				

						
						
					</div>
					{/* <div className="col-xl-4">
							
					</div> */}
				</div>
			</div>
		)
	}
};

export default Reports;